import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import barometer from '@/components/env-bigData/barometer';
import dataSummary from '@/components/env-bigData/dataSummary';
import realData from '@/components/env-bigData/realData';
import conserve from '@/components/env-bigData/conserve';
import { ACCESS_TOKEN } from '@/store/mutation-types'; // 预警组件

import systemWarning from '@/components/env-bigData/systemWarning';
import { getAction } from '@/api/manage';
import { queryEnergyAnalysis } from '@/api/api';
import Vue from 'vue';
import Img from "../../../../visual/dataScreen/js/option/components/img.vue";
export default {
  components: {
    border: border,
    systemWarning: systemWarning,
    conserve: conserve,
    barometer: barometer,
    dataSummary: dataSummary,
    realData: realData,
    Img: Img
  },
  data: function data() {
    return {
      isShow: true,
      DataSum: {},
      defaultValue: 1,
      defaultValue2: 1,
      analysisType: '11',
      analysisType2: '11',
      analysisHeight: '',
      calendarHeight: '',
      warnHeight: '',
      siteId: '259',
      showState: true,
      siteDetail: {},
      showToast: false,
      stand: [],
      siteWarnList: [],
      toastText: '',
      showCalendar: true,
      warnState: true,
      showDetail: false,
      showIt: false,
      showPie: true,
      quantum: '',
      standardList: [],
      radioIndex: '',
      radioStatu: true,
      showRadio: true,
      showAnalysis: false,
      title: [],
      timer: null,
      timer1: null,
      timer2: null,
      token: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log('token', Vue.ls.get(ACCESS_TOKEN));
    this.token = Vue.ls.get(ACCESS_TOKEN); //自适应

    this.resetWidth();
    window.addEventListener('resize', this.resetWidth, false);
    this.initData();
    this.timer = setInterval(function () {
      _this.initData();
    }, 180000);
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    window.removeEventListener('resize', this.resetWidth);
    clearInterval(this.Inter);
  },
  methods: {
    select: function select() {
      this.isShow = !this.isShow;
    },
    // 获取所有数据
    initData: function initData() {
      this.getPolutionData('1');
      this.getPolutionData('2');
      this.getDataSum();
    },
    getDataSum: function getDataSum() {
      var _this2 = this;

      // 请求数据
      getAction('/online/st54/summary/259').then(function (res) {
        if (res.success) {
          _this2.DataSum = res.result;
        }
      });
    },
    // 节能减排的tab切换
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        // analysisType用于控制查询的水质趋势的类型  11:小时数据  12:日数据
        case 1:
          this.analysisType = 11;
          this.getPolutionData('1', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('1', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('1', this.getDay(30));
          break;
      }
    },
    // 气压的tab切换
    changeRadio2: function changeRadio2(e) {
      var time;

      switch (e.target.value) {
        // analysisType用于控制查询的水质趋势的类型  11:小时数据  12:日数据
        case 1:
          this.analysisType2 = 11;
          this.getPolutionData('2', this.getDay(0));
          break;

        case 2:
          this.analysisType2 = 12;
          this.getPolutionData('2', this.getDay(7));
          break;

        case 3:
          this.analysisType2 = 12;
          this.getPolutionData('2', this.getDay(30));
          break;
      }
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取水质趋势
    getPolutionData: function getPolutionData(type, start) {
      var _this3 = this;

      if (!start) start = this.getDay(0);
      queryEnergyAnalysis({
        scopeId: this.siteId,
        type: type == '1' ? this.defaultValue : this.defaultValue2,
        stime: start,
        etime: this.getDay(0),
        dataType: type == '1' ? this.analysisType : this.analysisType2
      }).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var obj = {};
            var popArr = [];
            var arr = [];
            var time = [];
            var labelData = [];
            var seriesData = {};

            if (type == 1) {
              res.result.query.factors.forEach(function (ele) {
                if (ele.code == 'p05012' || ele.code == 'p05013') {
                  labelData.push(ele.title);
                  res.result.records.forEach(function (element) {
                    if (element.factor[ele.code]) {
                      obj.name = element.dateStr;
                      obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                      arr.push(obj);
                      obj = {};
                    }
                  });
                }

                seriesData.data = arr;
                seriesData.title = ele.title;
                popArr.push(seriesData);
                seriesData = {};
                arr = [];
              });
              res.result.records.forEach(function (data) {
                time.push(data.dataTime);
              });
            } else {
              res.result.query.factors.forEach(function (ele) {
                if (ele.code == 'p04000') {
                  res.result.records.forEach(function (element) {
                    if (element.factor[ele.code]) {
                      obj.name = element.dateStr;
                      obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                      arr.push(obj);
                      obj = {};
                    }
                  });
                }

                seriesData.data = arr;
                seriesData.title = ele.title;
                popArr.push(seriesData);
                seriesData = {};
                arr = [];
              });
              res.result.records.forEach(function (data) {
                time.push(data.dataTime);
              });
            }

            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;
              setTimeout(function () {
                type == '1' ? _this3.$refs.conserve.initBarChart(popArr, time, labelData) : _this3.$refs.conserve2.initBarChart(popArr, time, labelData);
              }, 100);
            });
          } else {
            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;
              setTimeout(function () {
                type == '1' ? _this3.$refs.conserve.initBarChart([], [], []) : _this3.$refs.conserve2.initBarChart([], [], []);
              }, 100);
            });
          }
        }
      });
    },
    resetWidth: function resetWidth() {
      this.$refs.border.width = document.documentElement.clientWidth * 0.45;
      this.$refs.border.height = document.documentElement.clientHeight * 0.54;
      this.$refs.border1.width = document.documentElement.clientWidth * 0.25;
      this.$refs.border1.height = document.documentElement.clientHeight * 0.26;
      this.$refs.border2.width = document.documentElement.clientWidth * 0.25;
      this.$refs.border2.height = document.documentElement.clientHeight * 0.26;
      this.calendarHeight = document.documentElement.clientHeight * 0.26 + 'px';
      this.$refs.border3.width = document.documentElement.clientWidth * 0.25;
      this.$refs.border3.height = document.documentElement.clientHeight * 0.26;
      this.$refs.border4.width = document.documentElement.clientWidth * 0.25;
      this.$refs.border4.height = document.documentElement.clientHeight * 0.26;
      this.warnHeight = document.documentElement.clientHeight * 0.3 + 'px';
      this.$refs.border5.width = document.documentElement.clientWidth * 0.48;
      this.$refs.border5.height = document.documentElement.clientHeight * 0.3;
      this.analysisHeight = document.documentElement.clientHeight * 0.29 + 'px';
      this.$refs.border6.width = document.documentElement.clientWidth * 0.48;
      this.$refs.border6.height = document.documentElement.clientHeight * 0.3;
    }
  }
};